var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0833 6.08317L13.9166 1.9165C13.75 1.74984 13.5833 1.6665 13.3333 1.6665H4.16663C2.74996 1.6665 1.66663 2.74984 1.66663 4.1665V15.8332C1.66663 17.2498 2.74996 18.3332 4.16663 18.3332H15.8333C17.25 18.3332 18.3333 17.2498 18.3333 15.8332V6.6665C18.3333 6.4165 18.25 6.24984 18.0833 6.08317ZM13.3333 16.6665H6.66663V11.6665H13.3333V16.6665ZM15.8333 16.6665C16.3333 16.6665 16.6666 16.3332 16.6666 15.8332V6.99984L13 3.33317H6.66663V5.83317H12.5C13 5.83317 13.3333 6.1665 13.3333 6.6665C13.3333 7.1665 13 7.49984 12.5 7.49984H5.83329C5.33329 7.49984 4.99996 7.1665 4.99996 6.6665V3.33317H4.16663C3.66663 3.33317 3.33329 3.6665 3.33329 4.1665V15.8332C3.33329 16.3332 3.66663 16.6665 4.16663 16.6665H4.99996V10.8332C4.99996 10.3332 5.33329 9.99984 5.83329 9.99984H14.1666C14.6666 9.99984 15 10.3332 15 10.8332V16.6665H15.8333Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_281_16403",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0833 6.08317L13.9166 1.9165C13.75 1.74984 13.5833 1.6665 13.3333 1.6665H4.16663C2.74996 1.6665 1.66663 2.74984 1.66663 4.1665V15.8332C1.66663 17.2498 2.74996 18.3332 4.16663 18.3332H15.8333C17.25 18.3332 18.3333 17.2498 18.3333 15.8332V6.6665C18.3333 6.4165 18.25 6.24984 18.0833 6.08317ZM13.3333 16.6665H6.66663V11.6665H13.3333V16.6665ZM15.8333 16.6665C16.3333 16.6665 16.6666 16.3332 16.6666 15.8332V6.99984L13 3.33317H6.66663V5.83317H12.5C13 5.83317 13.3333 6.1665 13.3333 6.6665C13.3333 7.1665 13 7.49984 12.5 7.49984H5.83329C5.33329 7.49984 4.99996 7.1665 4.99996 6.6665V3.33317H4.16663C3.66663 3.33317 3.33329 3.6665 3.33329 4.1665V15.8332C3.33329 16.3332 3.66663 16.6665 4.16663 16.6665H4.99996V10.8332C4.99996 10.3332 5.33329 9.99984 5.83329 9.99984H14.1666C14.6666 9.99984 15 10.3332 15 10.8332V16.6665H15.8333Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_281_16403)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveHome);
export default __webpack_public_path__ + "static/media/saveHome.476304e8c772eeb7564f5a082c688a05.svg";
export { ForwardRef as ReactComponent };